import React, { useEffect } from 'react'
import { withRouter } from 'react-router'
import { connect, useDispatch } from 'react-redux'
import { minAvisosEnFacetas } from '@navent-jobs/interlinking'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { BASE_URL, NOMBRE_SITIO, OG_ID_BY_SITE, SITE_ID } from '../../../../constants'
import features from '../../../../constants/features-per-country'
import { listadoAvisosItemList, listadoAvisosOccupationSalary } from '../../../../constants/listado-avisos-metas'
import { getPromedioSalarialArea } from '../../../../redux/actions/promedioSalarial'

const noIndexFollow = total => {
  return total < minAvisosEnFacetas
}

const googleAdsListEnabled = features[SITE_ID || 'BMAR'].googleAds?.list?.enabled
const googleAdsPaginationEnabled = features[SITE_ID || 'BMAR'].googleAds?.pagination?.enabled

const Metas = ({ breadcrumbs, listadoAvisos, match, location, promedioSalarialSubarea, filtersApplied }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const pageTitle = listadoAvisos.seoWordings.title
  const pageParam = Number(new URLSearchParams(location.search).get('page'))
  const ulrCanonical = `${BASE_URL}${match.url}`
  const { totalPages } = listadoAvisos.pagination

  useEffect(() => {
    if (pageParam === 0) {
      const area = filtersApplied?.find(item => item.type === 'area')
      const subarea = filtersApplied?.find(item => item.type === 'subarea')
      const onlySubareaFilterApplied = filtersApplied?.length === 2 && area && subarea
      if (onlySubareaFilterApplied) {
        dispatch(getPromedioSalarialArea(area.idSemantico || area.id))
      }
    }
  }, [filtersApplied])

  return listadoAvisos && listadoAvisos.seoWordings ? (
    <Helmet>
      <title>{pageTitle}</title>
      <meta property="og:title" content={pageTitle} />
      <meta property="og:site_name" content={NOMBRE_SITIO} />
      <meta property="og:url" content={ulrCanonical + (pageParam && pageParam !== 0 ? `?page=${pageParam}` : '')} />
      <meta property="fb:app_id" content={OG_ID_BY_SITE[NOMBRE_SITIO]} />

      <link rel="canonical" href={ulrCanonical + (pageParam && pageParam !== 0 ? `?page=${pageParam}` : '')} />
      {pageParam !== 0 && pageParam !== 1 && (
        <link rel="prev" href={`${ulrCanonical}${pageParam - 1 > 1 ? `?page=${pageParam - 1}` : ''}`} />
      )}
      {pageParam - 1 !== totalPages && (
        <link rel="next" href={`${ulrCanonical}?page=${pageParam + (pageParam === 0 ? 2 : 1)}`} />
      )}

      {noIndexFollow(listadoAvisos.grandTotal || listadoAvisos.totalAvisos) && (
        <meta name="robots" content="noindex, nofollow" />
      )}
      {breadcrumbs && <script type="application/ld+json">{breadcrumbs.json}</script>}

      <script type="application/ld+json">{listadoAvisosItemList(listadoAvisos.avisos)}</script>

      {(googleAdsListEnabled || googleAdsPaginationEnabled) && (
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6635751356116235"
          crossOrigin="anonymous"
        ></script>
      )}

      {promedioSalarialSubarea && pageParam === 0 && (
        <script type="application/ld+json">
          {listadoAvisosOccupationSalary(promedioSalarialSubarea, t(`currencyMask.code`))}
        </script>
      )}
    </Helmet>
  ) : null
}

const MetasWithRoute = withRouter(Metas)

const states = ({ listadoAvisosStore, breadcrumbsStore, promedioSalarialStore, filtersStore }) => {
  const { filtersApplied } = filtersStore
  const subarea = filtersApplied?.find(item => item.type === 'subarea')
  return {
    breadcrumbs: breadcrumbsStore.breadcrumbs,
    listadoAvisos: listadoAvisosStore,
    promedioSalarialSubarea: promedioSalarialStore?.promedioArea?.subareas?.find(item =>
      subarea?.idSemantico ? item.idSemantico === subarea?.idSemantico.split('|')[1] : item.idSemantico === subarea?.id
    ),
    filtersApplied,
  }
}

export default connect(states)(MetasWithRoute)
